<script>
import { Link, useLocation } from "svelte-navigator";
import { NavLinks } from './theme';

const location = useLocation();
</script>

<div class="nav col">
  {#each NavLinks as link}
    <Link to={link.to}>
      <div class="tile-row row vcenter" class:active={$location.pathname === link.to}>
        <div class="tile centercenter">
          {#if link.icon[0] === '/'}
            <img src={link.icon} class="image-icon" />
          {:else}
            <span class="material-icons">{link.icon}</span>
          {/if}
        </div>
        <div class="text">{link.name}</div>
      </div>
    </Link>
  {/each}
</div>

<style lang="scss">
@import './util';
@import './theme';

$hoverWidth: 250px;

.nav {
  position: fixed;
  z-index: 10;
  left: 0;
  top: 80px;
  bottom: 0px;
  width: 80px;
  background-color: $navbar-background-color;
  padding-top: 12px;
  transition: ease-out 250ms;
  overflow: hidden;
  color: white;
  user-select: none;
  
  @include mobile {
    display: none;
  }
}

.nav:hover {
  width: $hoverWidth;
}

.tile-row {
  cursor: pointer;
  padding-right: 16px;

  // Fix the width to prevent word-wrapping text movement during animated width updates
  width: $hoverWidth;
}

.tile-row:hover {
  background-color: $navbar-active-background-color;
  color: $navbar-active-color;
}

.tile-row.active {
  background-color: $navbar-active-background-color;
  color: $navbar-active-color;
}

.tile-row.active .tile {
  color: $navbar-background-color;
}

.tile-row:hover .image-icon {
  // Computed via: https://codepen.io/sosuke/pen/Pjoqqp
  // TODO cleaner method
  filter: brightness(0) saturate(100%) invert(14%) sepia(68%) saturate(0%) hue-rotate(184deg) brightness(96%) contrast(86%);
}

.tile-row.active .image-icon {
  filter: brightness(0) saturate(100%) invert(14%) sepia(68%) saturate(0%) hue-rotate(184deg) brightness(96%) contrast(86%);
}

.tile {
  height: 48px;
  width: 80px;
  flex-shrink: 0;
  color: white;
}

.tile-row:hover .tile {
  color: var(--gray5);
}

.text {
  font-size: 16px;
  font-weight: normal;
}
</style>